import { escapeHtml, formatAgo, formatCount } from '../format';

export type ConnectionState = 'live' | 'loading' | 'error';

export interface StatusState {
  state: ConnectionState;
  shown: number;
  total: number;
  updatedAt: number | null;
  /** Share of vehicles running less than three minutes late, 0…1. */
  punctuality: number | null;
  message: string | null;
}

/** The little "LIVE · 312 Fahrzeuge · vor 3s" pill in the corner. */
export class StatusBar {
  private state: StatusState = {
    state: 'loading',
    shown: 0,
    total: 0,
    updatedAt: null,
    punctuality: null,
    message: null,
  };

  constructor(private readonly root: HTMLElement) {
    // The "updated N seconds ago" text has to keep ticking between polls.
    window.setInterval(() => this.render(), 1000);
    this.render();
  }

  set(patch: Partial<StatusState>): void {
    this.state = { ...this.state, ...patch };
    this.render();
  }

  private render(): void {
    const { state, shown, total, updatedAt, punctuality, message } = this.state;
    const label = state === 'error' ? 'Offline' : state === 'loading' ? 'Lädt' : 'Live';

    const parts: string[] = [
      `<span class="status-live"><span class="status-dot" data-state="${state}"></span>${label}</span>`,
    ];

    if (message) {
      parts.push(`<span>${escapeHtml(message)}</span>`);
    } else {
      const filtered = shown !== total ? ` <span style="opacity:.6">/ ${formatCount(total)}</span>` : '';
      parts.push(
        '<span class="status-sep"></span>',
        `<span><b>${formatCount(shown)}</b>${filtered} Fahrzeuge</span>`,
      );
      if (updatedAt) {
        parts.push('<span class="status-sep"></span>', `<span>${formatAgo(updatedAt)}</span>`);
      }
      if (punctuality !== null) {
        const percent = Math.round(punctuality * 100);
        parts.push(
          '<span class="status-sep"></span>',
          `<span class="punctuality" title="Anteil der Fahrzeuge mit weniger als 3 Minuten Verspätung">` +
            `<span class="punctuality-bar"><span class="punctuality-fill" style="width:${percent}%"></span></span>` +
            `<b>${percent}%</b> pünktlich</span>`,
        );
      }
    }

    this.root.innerHTML = parts.join('');
  }
}
